<template>
  <div class="basicInformation common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <span>{{ $t('general.BasicInfo') }}</span>
    </div>
    <div class="common_readonly_template">
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.an') }}</div>
            <div class="text">{{ basicData.activityCode }}</div>
          </div>
        </el-col>
        <!-- <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.fs') }}</div>
            <div class="text">{{ basicData.financialSystemName }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.toc') }}</div>
            <div class="text">{{ basicData.currencyType }}</div>
          </div>
        </el-col> -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.ct') }}</div>
            <div class="text">{{ basicData.unionChannelType }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.cn') }}</div>
            <commonTooltip class="text" ref-name="basicDataApplyUserNameRef" :content="basicData.applyUserName" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.at') }}</div>
            <div class="text">{{ basicData.applyTime }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.cs') }}</div>
            <commonTooltip class="text" ref-name="basicDataSalerRef" :content="basicData.saler" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.ci') }}</div>
            <div class="text">{{ basicData.applyUserTel }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.hc') }}</div>
            <div class="text">{{ basicData.city }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.Poa') }}</div>
            <div class="text">{{ basicData.activityGoal }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.otherClassification">
          <div>
            <div class="label">{{ $t('newApp.BasicInfo.Oc') }}</div>
            <div class="text">{{ basicData.otherClassification }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.coa') }}</div>
            <div class="text">{{ basicData.activityClassification }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.relatedActivityName && basicData.relatedActivityCode">
          <div>
            <div class="label">{{ basicData.relationActivityName }}</div>
            <commonTooltip class="text" ref-name="basicDataRelatedActivityName" :content="hdActiveValue" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.noa') }}</div>
            <commonTooltip class="text" ref-name="basicDataActivityName" :content="basicData.activityName" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.targetObject">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.mta') }}</div>
            <div class="text">{{ formatTargetObject(basicData.targetObject, basicData.targetObjectOther) }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.organizer">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.Organizer') }}</div>
            <div class="text">{{ basicData.organizer }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.foa') }}</div>
            <div class="text">{{ basicData.activityForms }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.toa') }}</div>
            <div class="text">{{ basicData.activityType }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.qdMeetingSegment">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.cms') }}</div>
            <div class="text">{{ basicData.qdMeetingSegment }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.tnoptbi') }}</div>
            <div class="text">{{ basicData.inviterNum }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.edoh') }}</div>
            <div class="text">{{ basicData.expectStartDate }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.eed') }}</div>
            <div class="text">{{ basicData.expectEndDate }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.activityBaseName">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.hdjd') }}</div>
            <div class="text">{{ basicData.activityBaseName }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="basicData.activityBaseContactInformation">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.jdlx') }}</div>
            <div class="text">{{ basicData.activityBaseContactInformation }}</div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="editEchoData.mactAgendaList && editEchoData.mactAgendaList.length > 0 && basicData.viewIndustry && basicData.viewIndustry.length > 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.Industry') }}</div>
            <commonTooltip class="text" ref-name="viewIndustry" :content="basicData.viewIndustry.join('，')" />
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="editEchoData.mactAgendaList && editEchoData.mactAgendaList.length > 0 && basicData.viewAgenda && basicData.viewAgenda.length > 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.Bitt') }}</div>
            <div class="text">{{ basicData.viewAgenda.join('，') }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="editEchoData.mactModuleList && editEchoData.mactModuleList.length > 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.teietcs') }}</div>
            <div class="text">{{ basicData.mactModuleList }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="editEchoData.mactProductLineList && editEchoData.mactProductLineList.length > 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.artpl') }}</div>
            <div class="text">{{ basicData.productlineSupplement }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="editEchoData.mactCommunicationScenarioList && editEchoData.mactCommunicationScenarioList.length > 0 && lang === 'zh-CN'">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.comsc') }}</div>
            <div class="text">{{ basicData.communicationScenarioList || '--' }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="editEchoData.mactAgendaList && editEchoData.mactAgendaList.length > 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.agenda') }}</div>
            <div class="text">{{ basicData.agendaList }}</div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ActivityBgA') }}</div>
            <div class="text">{{ basicData.activityBackgroundPurpose || '--' }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { arrRemoveDuplication } from '@/utils/utils';
import commonTooltip from '@/components/commonTooltip';
import { isNotEmpty } from '../../../../../utils/utils';
import { targetObjectDisplayMixin } from '@/views/newApplicationForm/mixins/targetObjectMixin';
export default {
  mixins: [targetObjectDisplayMixin],
  props: {
    editEchoData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {
    commonTooltip
  },
  data () {
    return {
      basicData: {},
      lang: localStorage.getItem('lang') || 'zh-CN'
    };
  },
  computed: {
    hdActiveValue () {
      let value = '';
      switch (this.basicData.activityClassificationCode) {
      case 'AC_03':
      case 'AC_06':
        value = this.basicData.hqActivityName;
        break;
      case 'AC_01':
        value = this.basicData.relatedActivityName;
        break;
      }
      return value;
    }
  },
  mounted () {
    this.basicData = {
      ...this.editEchoData.marketActivityExpand,
      ...this.editEchoData.marketActivity
    };
    this.basicData.userData = `${this.basicData.applyUserName} / ${this.basicData.applyUserDeptName}`;
    this.basicData.saler = `${this.basicData.salerName} / ${this.basicData.salerDeptName}`;
    switch (this.basicData.activityClassificationCode) {
      case 'AC_03':
      case 'AC_06':
        this.basicData.relationActivityName = this.$t('home.ha');
        break;
      case 'AC_01':
        this.basicData.relationActivityName = this.$t('newApp.activityInfo.ta');
        break;
    }
    if (this.editEchoData.mactAgendaList && this.editEchoData.mactAgendaList.length > 0) {
      // 议程回显
      this.basicData.viewAgenda = [];
      this.editEchoData.mactAgendaList.forEach(item => {
        if (item.agendaName && item.agendaName !== '无') {
          this.basicData.viewAgenda.push(item.agendaName);
        }
      });
      // 行业回显
      let industryList = arrRemoveDuplication(this.editEchoData.mactAgendaList, 'industryCode');
      this.basicData.viewIndustry = [];
      industryList.forEach(item => {
        if (item.industryName) {
          this.basicData.viewIndustry.push(item.industryName);
        }
      });
    }
    // 活动预计板块
    if (this.editEchoData.mactModuleList && this.editEchoData.mactModuleList.length > 0) {
      this.basicData.mactModuleList = this.editEchoData.mactModuleList.map(item => {
        return item.moduleName;
      }).join('，');
    }
    // 产品线
    if (this.editEchoData.mactProductLineList && this.editEchoData.mactProductLineList.length > 0) {
      this.basicData.productlineSupplement = this.editEchoData.mactProductLineList.map(item => {
        if (item.productLineName.indexOf('其他') >= 0) {
          item.productLineName = item.customProductLine;
        }
        return item.productLineName;
      }).join('，');
    }
    if (isNotEmpty(this.editEchoData.mactCommunicationScenarioList)) {
      this.basicData.communicationScenarioList = this.editEchoData.mactCommunicationScenarioList.map(item => {
        return item.communicationScenarioName;
      }).join('，');
    }
    if (isNotEmpty(this.editEchoData.mactAgendaList)) {
      this.basicData.agendaList = this.editEchoData.mactAgendaList.map(item => {
        return item.agendaName;
      }).join('，');
    }
    console.log(this.basicData);
  }
};
</script>

<style lang="scss" scoped>
.basicInformation{
  >.contentBox{
    >.el-row{
      >.el-col{
        line-height: 36px;
        margin-bottom: 14px;
        &:after{
          content: '';
          clear: both;
          display: block;
        }
        >.label{
          padding-left: 5px;
          width: 140px;
          height: 36px;
          float: left;
          color: #909399;
          box-sizing: border-box;
        }
        >.text{
          margin-left: 140px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
      }
      >.folding{
        >.label{
          width: auto;
          float: none;
        }
        >.text{
          margin-left: 5px;
          overflow: visible;
          text-overflow: clip;
          white-space: normal;
        }
      }
    }
  }
}
</style>
